<template>
    <div class="mt-0">
        <div class="row p-2 mt-3" id="lower-div">
            <div class="card mb-4">
                <div v-loading="loading">
                    <Table @get-data="GetExceptionTypes" :data="data"></Table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Table from "./Components/Table.vue";

export default {
    components: {
        Table
    },
    data() {
        return {
            firstVis: true,
            loading: null,
            data:[
                {
                    check: true,
                    value: "Ürəyin işemik xəstəliyi."
                },
                {
                    check: true,
                    value: "Yüksək qan təzyiqi."
                },
                {
                    value: "Şəkərli diabet."
                },
                {
                    value: "Astma."
                },
                {
                    value: "Qaraciyər xəstəlikləri (hepatit, sirroz)."
                },
                {
                    value: "Beyin insultu və ya sinir sistemi xəstəlikləri."
                }
            ],
            navNumber: 1
        }
    },
}
</script>